import { LayoutGroup, motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { isTabActive, TABS } from "./navTabs";

export function BottomTabBar() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <nav
      aria-label="Primary"
      className="absolute inset-x-0 bottom-0 h-[72px] border-t border-line bg-bg-deep/90 backdrop-blur"
    >
      <LayoutGroup>
        <ul className="flex h-full items-center justify-around">
          {TABS.map((tab) => {
            const active = isTabActive(location.pathname, tab.to);
            return (
              <li key={tab.to}>
                <Link
                  to={tab.to}
                  aria-current={active ? "page" : undefined}
                  className={`relative flex min-h-[48px] flex-col items-center justify-center gap-1 rounded-full px-4 py-1 text-[11px] font-medium ${
                    active ? "text-volt" : "text-fg-mute hover:text-fg"
                  }`}
                >
                  {active && (
                    <motion.span
                      layoutId="active-tab-pill"
                      className="absolute inset-0 -z-10 rounded-full bg-volt/15 volt-stroke"
                      transition={{ type: "spring", stiffness: 380, damping: 30 }}
                    />
                  )}
                  <span className="h-5 w-5">{tab.icon}</span>
                  <span>{t(tab.i18nKey)}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </LayoutGroup>
    </nav>
  );
}
